import { OpsSeverity, OpsSeverityLabels } from '@navio/nsdk';
import { NoddiBadge, type BadgeVariant } from 'noddi-ui-web';

const VARIANT: Record<OpsSeverity, BadgeVariant> = {
  [OpsSeverity.CRITICAL]: 'destructive',
  [OpsSeverity.HIGH]: 'warning',
  [OpsSeverity.MEDIUM]: 'outline',
  [OpsSeverity.LOW]: 'outline'
};

export const SeverityBadge = ({ severity }: { severity: OpsSeverity }) => (
  <NoddiBadge variant={VARIANT[severity]}>{OpsSeverityLabels[severity]}</NoddiBadge>
);
